import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={17}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.68.5H2.047C1.053.5.273 1.3.273 2.274v14.952c0 .994.8 1.774 1.774 1.774H14.66c.994 0 1.774-.8 1.774-1.774V2.274A1.751 1.751 0 0 0 14.68.5ZM4.757 14.906h-.273a.894.894 0 0 1-.897-.897c0-.487.39-.896.897-.896h.273c.487 0 .897.39.897.896 0 .488-.39.897-.897.897Zm0-4.25h-.273a.894.894 0 0 1-.897-.896c0-.488.39-.897.897-.897h.273c.487 0 .897.39.897.897 0 .487-.39.896-.897.896Zm0-4.25h-.273a.894.894 0 0 1-.897-.896c0-.507.39-.897.897-.897h.273c.487 0 .897.39.897.897s-.39.897-.897.897Zm7.486 8.5H7.759a.894.894 0 0 1-.897-.897c0-.487.39-.896.897-.896h4.503c.488 0 .897.39.897.896-.02.488-.429.897-.916.897Zm0-4.25H7.759a.894.894 0 0 1-.897-.896c0-.488.39-.897.897-.897h4.503c.488 0 .897.39.897.897-.02.487-.429.896-.916.896Zm0-4.25H7.759a.894.894 0 0 1-.897-.896c0-.507.39-.897.897-.897h4.503c.488 0 .897.39.897.897s-.429.897-.916.897Z"
      fill="#636F7C"
    />
  </svg>
);

export default SvgComponent;
